import { Quaternion, Vector3 } from 'three';
import { poseAvatarSeated } from './avatarMotion.js';

// The source mesh is baked in island coordinates; runtime motion uses a hull
// pivot at this authored centre and one shore-side mooring destination.
export const BOAT_MESH_ORIGIN = Object.freeze({ x: -9.4, y: .35, z: -5.4 });
export const BOAT_MOOR = Object.freeze({ x: 13.7, z: 8.85 });
// SeatA is behind the mast, clear of the sail. Thighs rest on the board and
// the slightly open knees leave space for the mast between the boots.
export const BOAT_SEAT = Object.freeze({ x: -.42, y: .41, z: 0 });
const seatYaw = new Quaternion().setFromAxisAngle(new Vector3(0, 1, 0), Math.PI / 2);
const seatOffset = new Vector3(), hipOffset = new Vector3();
const boatRotation = new Quaternion(), parentRotation = new Quaternion();

export function isBoatPassenger(trip, fishingSession) {
  return Boolean(trip || fishingSession?.fromBoat);
}

export function seatAvatarInBoat(actor, boat, options) {
  if (!actor || !boat) return;
  poseAvatarSeated(actor, options);
  const rig = actor.userData.seatedRig;
  if (!rig) return;
  hipOffset.copy(rig.hip).multiply(actor.scale).applyQuaternion(seatYaw);
  seatOffset.set(BOAT_SEAT.x, BOAT_SEAT.y + .09, BOAT_SEAT.z).sub(hipOffset);
  boat.updateWorldMatrix(true, false);
  seatOffset.applyMatrix4(boat.matrixWorld);
  if (actor.parent) actor.parent.worldToLocal(seatOffset);
  actor.position.copy(seatOffset);
  boat.getWorldQuaternion(boatRotation).multiply(seatYaw);
  if (actor.parent) boatRotation.premultiply(actor.parent.getWorldQuaternion(parentRotation).invert());
  actor.quaternion.copy(boatRotation);
}

export function boatFloatOffset(waterY, timeSeconds) {
  // The GLB keel is .27 m above its original origin, so this puts the keel
  // about .02 m above the flat water plane while preserving a shallow draft.
  return waterY - .25 + Math.sin(timeSeconds * 1.4) * .025;
}
